import { T as ThemeModePreference } from './ThemeMode-DBlsP3Iq.js';
import { S as STORAGE_KEY } from '../../constants-BAsg3-1S.js';

/**
 * Retrieves the stored theme mode from localStorage
 * @returns {ThemeModePreference} The stored mode or LIGHT as default
 */
var getStoredThemeMode = () => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return ThemeModePreference.LIGHT;
  }
  try {
    const storedMode = localStorage.getItem(STORAGE_KEY);
    if (storedMode === ThemeModePreference.DARK) {
      return ThemeModePreference.DARK;
    }
    if (storedMode === ThemeModePreference.SYSTEM) {
      return ThemeModePreference.SYSTEM;
    }
  } catch (_unused) {
    // localStorage access can fail in private browsing or when disabled
  }
  return ThemeModePreference.LIGHT;
};

export { getStoredThemeMode as g };
//# sourceMappingURL=getStoredThemeMode-Dpg19Fxu.js.map
